/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {
  currentProjectDetails: Object,
};

@inject('actionDrawerStore')
@observer
export default class EditProjectSuccess extends React.Component<*> {
  render(): React.Node {
    const { t }: TypeProps = this.props;

    return (
      <div className={styles['action-drawer-content']}>
        <div>
          <h3>{t('general:success')}</h3>
        </div>
        {/* No content yet */}
      </div>
    );
  }
}
